import React, { useState } from "react";
import { EfficiencyStockChart, LineEfficiencyChart } from "./index";
import SubTabNav from "../common/SubTabNav";

interface EfficiencyChartContainerProps {
  machineSerialNo?: string;
  lineId?: string; // Line ID for line-level aggregated data
  shifts?: string[];
  className?: string;
  syncGroup?: string;
  activeSubTab?: "efficiency" | "utilization";
  onActiveSubTabChange?: (tab: "efficiency" | "utilization") => void;
}

const EfficiencyChartContainer: React.FC<EfficiencyChartContainerProps> = ({
  machineSerialNo,
  lineId,
  shifts,
  className = "",
  syncGroup,
  activeSubTab,
  onActiveSubTabChange,
}) => {
  const [internalActiveTab, setInternalActiveTab] = useState<
    "efficiency" | "utilization"
  >("efficiency");

  // Use external state if provided, otherwise use internal state
  const activeTab =
    activeSubTab !== undefined ? activeSubTab : internalActiveTab;
  const setActiveTab = onActiveSubTabChange || setInternalActiveTab;

  const tabs = [
    { key: "efficiency", label: "Efficiency" },
    { key: "utilization", label: "Utilization" },
  ];

  return (
    <div className={`space-y-4 ${className}`}>
      {/* Subtab navigation */}
      <SubTabNav
        tabs={tabs}
        activeTab={activeTab}
        onTabChange={(tab) => setActiveTab(tab as "efficiency" | "utilization")}
      />

      {/* Line view uses the line-level request (per-machine series); machine
          view uses the per-shift stock chart. */}
      {lineId ? (
        <LineEfficiencyChart
          lineId={lineId}
          shifts={shifts}
          activeTab={activeTab}
        />
      ) : (
        <EfficiencyStockChart
          machineSerialNo={machineSerialNo}
          lineId={lineId}
          shifts={shifts}
          syncGroup={syncGroup}
          activeTab={activeTab}
        />
      )}
    </div>
  );
};

export default EfficiencyChartContainer;
